import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './auth/guard/auth.guard';
import { CustomerPolicyComponent } from './external/customer-policy/customer-policy.component';
import { RiderPolicyComponent } from './external/rider-policy/rider-policy.component';
const routes: Routes = [
  { path: '', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
  { path: 'weClean', loadChildren: () => import('./core/core.module').then(m => m.CoreModule), canActivate: [AuthGuard] },
  { path: 'Mobile', loadChildren: () => import('./external/mobile-payment/mobile-payment.module').then(m => m.MobilePaymentModule), canActivate: [AuthGuard] },
  // { path: 'customer-policy', loadChildren: () => import('./external/customer-policy/customer-policy.module').then(m => m.CustomerPolicyModule) },
  // { path: 'rider-policy', loadChildren: () => import('./external/rider-policy/rider-policy.module').then(m => m.RiderPolicyModule)},
  { path: 'customer-policy', component: CustomerPolicyComponent },
  {path : 'rider-policy', component : RiderPolicyComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

